import {useCallback, useEffect, useRef} from 'react';

/**
 *
 * @template T
 * @template V
 * @param {(isCancelled: () => boolean, ...args: T) => Promise<V>} cb
 * @param {any[]} deps
 * @returns {(...args: T) => Promise<V>}
 */
const useAsyncCallback = (cb, deps) => {
  const unmounted = useRef(false);

  const fn = useCallback((...args) => {
    const isCancelled = () => unmounted.current;
    return cb(isCancelled, ...args);
  }, deps);

  useEffect(() => () => {
    unmounted.current = true;
  }, []);

  return fn;
};

export default useAsyncCallback;
